<template>
    <div>
        <nav aria-label="Back">
            <span @click="back" class="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:cursor-pointer">
                <ChevronLeftIcon class="flex-shrink-0 -ml-1 mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                Zurück
            </span>
        </nav>
        <div class="mt-2 md:flex md:items-center md:justify-between">
            <div class="flex-1 min-w-0">
                <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate" id="title">
                    <slot></slot> {{ farm ? '('+farm.name+')' : '' }}
                </h2>
            </div>
            <slot name="buttons"></slot>
        </div>
    </div>
</template>

<script>
import { ChevronLeftIcon } from "@heroicons/vue/solid";

export default {
    name: "FarmTitle",
    props: ['farm'],
    components: {ChevronLeftIcon},
    mounted() {
        document.title = document.getElementById('title') ? document.getElementById('title').innerText + ' | hof.services' : 'hof.services'
    },
    methods: {
        back() {
            window.history.back();
        }
    }
}
</script>

<style scoped>

</style>
